export const PREDICTED_UTILITIES_SEPARATOR = ' ___ '
